import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import authStore from '../auth-store'
import authUtils from './auth-utils'

export default async function login(context: BareActionContext<AuthState, RootState>) {
  if (!authStore.isAuthenticated) {
    authUtils.authService.login()
  }
}
